import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from '../../../../../../app/core/services/profile.service';
import { AppActionCheck } from '../../../../../../app/core/utils/app-action-check';
import { AppErrorShow } from '../../../../../../app/core/utils/app-error-show';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../shared/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';


@Component({
  selector: 'ngx-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe,
        NgSelectModule
  ]
})
export class ProfileComponent implements OnInit {
  selected_data:any
  data:any[]=[]
  user:any
  currentPermission:any
  buttonsPermission :any|undefined;
  windiow:any
  windiowName:any
  features:any[]=[]
  permissions:any[]=[]
  permissionsList:any[]=[]
  permissionsChosen:any[]=[]
  loading=false
  loading2=false
  tag="Profils"


      constructor(
        private locService:LocalStorageService, 
        private profileService:ProfileService,
        private toastrService:ToastrService,
        private dialogService:NgbModal,
        private modalService:NgbModal

        ){
  
      } 
  
    ngOnInit(): void {
      this.all();
      this.user=this.locService.get(GlobalName.userName);
      this.permissions=this.user.roles[0]?.permissions;
     
      this.getActions()
    }
  
    all() {
      this.loading2=true;
      this.profileService.getAll().subscribe((res:any)=>{
        this.data=res.roles
        this.permissionsList=res.permissions
        this.loading2=false;
        
      },
      (error:any)=>{
        
        this.loading2=false;
        AppErrorShow.showError("Gestion des profils",error)

      })
    }
  
    checked(el:any){
      this.selected_data=el
    }
  
    
    open(dialog: TemplateRef<any>,el:any) {
      this.selected_data=el
      this.dialogService.open(
        dialog);
        
    }
  
    store(value:any,ref:any) {
      this.toastrService.info("Profil","Ajout de Opération en cours")

      // this.loading=true;
      // let permissionSelected:any[]=[]
      // this.permissionsChosen.forEach((el:any)=>{
      //   let checkStateOn=el.children.filter((elm:any)=>elm.status == true)
      //   if (checkStateOn.length!=0) {
      //     checkStateOn.forEach((el2:any)=>{
      //       permissionSelected.push(el2.id)
      //     })
      //   }
      // })
      // console.log(permissionSelected)
        this.loading=true
        this.profileService.store({
          id:this.selected_data.id,
          permissionsChosen:value.permissionsChosen
        }).subscribe(
            (res:any)=>{
            this.loading=false;
            this.modalService.dismissAll()
            this.all();
            this.toastrService.success("Profil","Ajout de droit")

        },
        (err:any)=>{
            this.loading=false;
            AppErrorShow.showError("Gestion des profils",err)

        })
  
  }
  hasPermission(permission:any){
    var check= this.permissionsList.find((e:any)=>e.name ==permission)
    if(check) return true;
    return false
  }

  revoke(id:any,id2:any){
    this.loading=true;
    if(confirm("Voulez vous retirer ce droit ?")){
      this.toastrService.info("Profil","Ajout de Opération en cours")
         this.profileService.update({id:id2},id).subscribe(
          (res:any)=>{
          this.loading=false;
          this.all();
          this.toastrService.success("Profil","Retrait de droit")


      },
      (err:any)=>{
          this.loading=false;
          AppErrorShow.showError("Gestion des profils",err)

      })
    }
   
  }

  setValue(i:any){
    this.permissions[i].value= !this.permissions[i].value
  }

  setChosen(ev:any){
    // this.currentPermission=this.permissionsList[ev.target.value]
    // this.windiow=JSON.parse(this.permissionsList[ev.target.value].window)
    // this.permissionsChosen=JSON.parse(this.permissionsList[ev.target.value].actions)
  }

  getJson(actions:any){
    return JSON.parse(actions)
  }

  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
   
  }
}
